import http from '@/utils/http';

export default {
	list: data => {
		return http({ url: '/api/admin/v1/roles/list', data }).then(r => r);
	},
	getAll: data => {
		return http({ url: '/api/admin/v1/roles/getAll', data }).then(r => r);
	},
	save: data => {
		return http({ url: '/api/admin/v1/roles/save', data, tip: true }).then(r => r);
	},
	delete: data => {
		return http({ url: '/api/admin/v1/roles/delete', data, tip: true }).then(r => r);
	},
};
